<script>import { onDestroy, onMount, setContext } from 'svelte';
export let tolgee;
export let fallback = undefined;
let isLoading = !tolgee.isLoaded();
setContext('tolgeeContext', {
    tolgee,
});
if (typeof window !== 'undefined') {
    onMount(() => {
        tolgee.run().finally(() => {
            isLoading = false;
        });
    });
    onDestroy(tolgee.stop);
}
</script>

{#if !isLoading }
  <slot />
{:else }
  {#if fallback}
    {fallback}
  {:else}
    <slot name="fallback" />
  {/if}
{/if}
